import { AppState } from '../../..';
import { ContractResaleEmailProperties, ContractResaleEmailComponent } from './contract-resale-email.component';
import { Dispatch, connect } from 'react-redux';
import { getContractResaleNoticiations, addEmail, removeEmail, sendResaleEmails } from '../../contract-resale.actions';
function mapStateToProps(state: AppState): Partial<ContractResaleEmailProperties> {
  return {
    resaleNotifications: state.contract.resaleNotifications,
    resaleEmails: state.contract.resaleEmailNotifications
  };
}

function mapDispatchToProps(dispatch: Dispatch<AppState>): Partial<ContractResaleEmailProperties> {
  return {
    addEmail: (email: string) => {
      dispatch(addEmail(email));
    },
    removeEmail: (email: string) => {
      dispatch(removeEmail(email));
    },
    getContractResaleEmailNotifications: (id: number) => {
      dispatch(getContractResaleNoticiations(id));
    },
    sendResaleEmails: (id: number, emails: Array<string>) => {
      dispatch(sendResaleEmails(id, emails));
    }
  };
}

export const ContractResaleEmail = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractResaleEmailComponent);



// WEBPACK FOOTER //
// ./src/contract/_components/contract-resale-email/contract-resale-email.container.ts